import { useGetOrganizationSummaryQuery } from 'shared/api/myOrganization';

const MyOrganizationBreadcrumb = () => {
  const { data: organization } = useGetOrganizationSummaryQuery();

  return <span>{organization?.name}</span>;
};

export { MyOrganizationBreadcrumb };
